import { defineMessages } from 'react-intl.macro';
import {
  PUBLISHSET_TYPES,
  PUBLISHSET_STATES,
  PUBLISHSET_FORM_TYPE,
  PUBLISHSET_IS_PAID,
  PUBLISHSET_ADMIN_ONLY,
} from '../constants';
import { DatatypeEnum } from '../../openapi/types/DatatypeEnum';
import { DtmDataTypeEnum } from '../../openapi/types/DtmDataTypeEnum';

export const publishsetMessages = defineMessages({
  publishsetListPageTitle: {
    id: 'publishsetList.PageTitle',
    defaultMessage: 'Přehled výdejních sad',
  },
  publishsetListStateWaiting: {
    id: 'publishsetList.state.waiting',
    defaultMessage: 'Seznam výdejních sad se načítá.',
  },
  publishsetListStateFail: {
    id: 'publishsetList.state.fail',
    defaultMessage: 'Seznam výdejních sad se nepovedlo načíst.',
  },
  name: {
    id: 'publishsetList.name',
    defaultMessage: 'Název',
  },
  priceListItemColumn: {
    id: 'publishsetList.priceListItemColumn',
    defaultMessage: 'Ceník',
  },
  type: {
    id: 'publishsetList.type',
    defaultMessage: 'Typ',
  },
  created: {
    id: 'publishsetList.created',
    defaultMessage: 'Vytvořeno',
  },
  published: {
    id: 'publishsetList.published',
    defaultMessage: 'Editováno',
  },
  tags: {
    id: 'publishsetList.tags',
    defaultMessage: 'Štítky',
  },
  publishsetListBtnNew: {
    id: 'publishsetList.btn.create',
    defaultMessage: 'Vytvořit výdejní sadu',
  },
  state: {
    id: 'publishsetList.state',
    defaultMessage: 'Stav',
  },
  creator: {
    id: 'publishsetList.creator',
    defaultMessage: 'Vytvořil',
  },
  editor: {
    id: 'publishsetList.editor',
    defaultMessage: 'Upravil',
  },
  isPaid: {
    id: 'publishsetList.isPaid',
    defaultMessage: 'Zpoplatnění',
  },
  adminOnly: {
    id: 'publishsetList.adminOnly',
    defaultMessage: 'Viditelnost',
  },
});

export const publishsetTitleMessages = defineMessages<PUBLISHSET_FORM_TYPE>({
  [PUBLISHSET_FORM_TYPE.NEW]: {
    id: 'publishset.edit.title.new',
    defaultMessage: 'Nová výdejní sada',
  },
  [PUBLISHSET_FORM_TYPE.EDIT]: {
    id: 'publishset.edit.title.edit',
    defaultMessage: 'Detail výdejní sady',
  },
});

export const publishsetFailMessages = defineMessages<PUBLISHSET_FORM_TYPE>({
  [PUBLISHSET_FORM_TYPE.NEW]: {
    id: 'publishset.fail.new',
    defaultMessage: 'Vytvoření nové výdejní sady se nepovedlo. Zkuste to prosím později.',
  },
  [PUBLISHSET_FORM_TYPE.EDIT]: {
    id: 'publishset.fail.edit',
    defaultMessage: 'Úpravy se nepovedlo uložit. Zkuste to prosím později.',
  },
});

export const publishsetQueryMessages = defineMessages({
  loadQueryStateWaiting: {
    id: 'publishset.load.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'publishset.load.queryState.fail',
    defaultMessage: 'Zobrazení informací o výdejní sadě se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateWaiting: {
    id: 'publishset.submit.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  submitQueryStateSuccess: {
    id: 'publishset.submit.queryState.success',
    defaultMessage: 'Úpravy uloženy.',
  },
  deleteQueryStateWaiting: {
    id: 'publishset.delete.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  deleteQueryStateFail: {
    id: 'publishset.delete.queryState.fail',
    defaultMessage: 'Smazání datové sady se nepovedlo. Zkuste to prosím později.',
  },
});

export const publishsetFormMessages = defineMessages({
  attachments: {
    id: 'publishset.attachments',
    defaultMessage: 'Přílohy',
  },
  publishsetAlertDelete: {
    id: 'publishset.edit.AlertDelete',
    defaultMessage: 'Chcete smazat výdejní sadu',
  },
  nameRequired: {
    id: 'publishset.name.validation.required',
    defaultMessage: 'Vyplňte název výdejní sady',
  },
  name: {
    id: 'publishset.edit.name',
    defaultMessage: 'Název',
  },
  description: {
    id: 'publishset.edit.description',
    defaultMessage: 'Popis',
  },
  externalDescriptionUrl: {
    id: 'publishset.edit.externalDescriptionUrl',
    defaultMessage: 'Podrobnosti',
  },
  tags: {
    id: 'publishset.edit.tags',
    defaultMessage: 'Štítky',
  },
  tileindex: {
    id: 'publishset.edit.tileindex',
    defaultMessage: 'Tileindex',
  },
  type: {
    id: 'publishset.edit.type',
    defaultMessage: 'Typ',
  },
  typeRequired: {
    id: 'publishset.type.validation.required',
    defaultMessage: 'Vyberte typ výdejní sady',
  },
  formats: {
    id: 'publishset.edit.formats',
    defaultMessage: 'Formáty',
  },
  formatsRequired: {
    id: 'publishset.formats.validation.required',
    defaultMessage: 'Vyberte formát výdejní sady',
  },
  approverRoles: {
    id: 'publishset.edit.approverRoles',
    defaultMessage: 'Schvalovatel',
  },
  state: {
    id: 'publishset.edit.state',
    defaultMessage: 'Stav',
  },
  creator: {
    id: 'publishset.edit.creator',
    defaultMessage: 'Vytvořil',
  },
  created: {
    id: 'publishset.edit.created',
    defaultMessage: '{created, date, ::ddMMMMyyyy} v {created, time, ::HHmm}',
  },
  editor: {
    id: 'publishset.edit.editor',
    defaultMessage: 'Poslední úprava',
  },
  edited: {
    id: 'publishset.edit.edited',
    defaultMessage: '{edited, date, ::ddMMMMyyyy} v {edited, time, ::HHmm}',
  },
  publishsetDatasetList: {
    id: 'publishset.edit.publishsetDatasetList',
    defaultMessage: 'Datové sady',
  },
  datasetName: {
    id: 'publishset.edit.publishsetDatasetList.dataset',
    defaultMessage: 'Název sady',
  },
  datasetFields: {
    id: 'publishset.edit.publishsetDatasetList.fields',
    defaultMessage: 'sloupce',
  },
  datasetCondition: {
    id: 'publishset.edit.publishsetDatasetList.condition',
    defaultMessage: 'podmínka',
  },
  confirmLeaveMessage: {
    id: 'publishset.edit.alert.confirmLeave',
    defaultMessage: 'Vaše změny nejsou uloženy. Přejete si přesto opustit stránku?',
  },
  datatype: {
    id: 'publishset.edit.datatype',
    defaultMessage: 'Datový typ',
  },
  dtmDataType: {
    id: 'publishset.edit.dtmDataType',
    defaultMessage: 'Datový typ',
  },
  dtmDataTypeRequired: {
    id: 'publishset.edit.dtmDataType.required',
    defaultMessage: 'Vyberte datový typ',
  },
  exportToolNoTool: {
    id: 'publishset.edit.exportToolNoTool',
    defaultMessage: 'Není přiřazen žádný exportní nástroj',
  },
  exportTool: {
    id: 'publishset.edit.exportTool',
    defaultMessage: 'Exportní nástroj',
  },
  exportToolSingle: {
    id: 'publishset.edit.exportToolSingle',
    defaultMessage: 'jediný dostupný nástroj',
  },
  exportToolsAvailable: {
    id: 'publishset.edit.exportToolsAvailable',
    defaultMessage:
      '{count, plural, one {# dostupný nástroj} few {# dostupné nástroje} other {# dostupných nástrojů}}',
  },
  typeHint: {
    id: 'publishset.edit.typeHint',
    defaultMessage: 'Sada obsahuje formáty jen jednoho typu. Změna typu zruší vybrané formáty.',
  },
  typeChangeConfirm: {
    id: 'publishset.edit.alert.typeChangeConfirm',
    defaultMessage:
      'Změna typu zruší výběr {count, plural, one {# formátu} few {# formátů} other {# formátů}}. Pokračovat?',
  },
  formatsSummary: {
    id: 'publishset.edit.formatsSummary',
    defaultMessage:
      '{selected, plural, =0 {Nevybrán žádný formát} one {Vybrán # z {total, plural, one {# formátu} other {# formátů}}} few {Vybrány # z {total, plural, one {# formátu} other {# formátů}}} other {Vybráno # z {total, plural, one {# formátu} other {# formátů}}}}',
  },
  formatsSummaryPackages: {
    id: 'publishset.edit.formatsSummaryPackages',
    defaultMessage:
      '{count, plural, one {# balíček vyžaduje tileindex} few {# balíčky vyžadují tileindex} other {# balíčků vyžaduje tileindex}}',
  },
  exportToolPackage: {
    id: 'publishset.edit.exportToolPackage',
    defaultMessage: 'Balíček',
  },
  tileindexRequired: {
    id: 'publishset.tileindex.validation.required',
    defaultMessage: 'U balíčku vyberte tileindex',
  },
  priceListItem: {
    id: 'publishset.edit.priceListItem',
    defaultMessage: 'Položka ceníku',
  },
  priceListItemHint: {
    id: 'publishset.edit.priceListItemHint',
    defaultMessage: 'Bez vybrané položky je sada zdarma.',
  },
  visibility: {
    id: 'publishset.edit.visibility',
    defaultMessage: 'Viditelnost',
  },
  adminOnly: {
    id: 'publishset.edit.adminOnly',
    defaultMessage: 'Neveřejná sada',
  },
  adminOnlyHint: {
    id: 'publishset.edit.adminOnlyHint',
    defaultMessage: 'Neveřejnou sadu vidí a objedná pouze administrátor.',
  },
});

export const publishsetTypesMessages = defineMessages<PUBLISHSET_TYPES>({
  [PUBLISHSET_TYPES.VECTOR]: {
    id: 'publishset.publishsettypes.VECTOR',
    defaultMessage: 'vektor',
  },
  [PUBLISHSET_TYPES.RASTER]: {
    id: 'publishset.publishsettypes.RASTER',
    defaultMessage: 'rastr',
  },
});

export const publishsetTypesLabelMessages = defineMessages<PUBLISHSET_TYPES>({
  [PUBLISHSET_TYPES.VECTOR]: {
    id: 'publishset.publishsettypes.VECTOR.label',
    defaultMessage: 'Vektor',
  },
  [PUBLISHSET_TYPES.RASTER]: {
    id: 'publishset.publishsettypes.RASTER.label',
    defaultMessage: 'Rastr',
  },
});

export const publishsetStateMessages = defineMessages<PUBLISHSET_STATES>({
  [PUBLISHSET_STATES.PREPARING]: {
    id: 'publishset.publishsetstate.PREPARING',
    defaultMessage: 'Rozpracovaná',
  },
  [PUBLISHSET_STATES.PUBLISHED]: {
    id: 'publishset.publishsetstate.PUBLISHED',
    defaultMessage: 'Publikovaná',
  },
  [PUBLISHSET_STATES.ARCHIVED]: {
    id: 'publishset.publishsetstate.ARCHIVED',
    defaultMessage: 'Archivovaná',
  },
});

export const publishsetBtnMessages = defineMessages({
  close: {
    id: 'publishset.btn.close',
    defaultMessage: 'Zavřít',
  },
  delete: {
    id: 'publishset.btn.delete',
    defaultMessage: 'Smazat',
  },
  cancel: {
    id: 'publishset.btn.cancel',
    defaultMessage: 'Zrušit změny',
  },
  save: {
    id: 'publishset.btn.save',
    defaultMessage: 'Uložit',
  },
  undo: {
    id: 'publishset.btn.undo',
    defaultMessage: 'Zpět na přehled výdejních sad',
  },
  clear: {
    id: 'publishset.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  create: {
    id: 'publishset.btn.create',
    defaultMessage: 'Vytvořit',
  },
  newPublishsetDataset: {
    id: 'publishset.btn.newPublishsetDataset',
    defaultMessage: 'Přidat datovou sadu',
  },
  filterSubmit: {
    id: 'publishset.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  filter: {
    id: 'publishset.btn.filter',
    defaultMessage: 'Filtr',
  },
});

export const publishsetIsPaidMessages = defineMessages<PUBLISHSET_IS_PAID>({
  [PUBLISHSET_IS_PAID.TRUE]: {
    id: 'publishsetList.isPaid.TRUE',
    defaultMessage: 'Zpoplatněné',
  },
  [PUBLISHSET_IS_PAID.FALSE]: {
    id: 'publishsetList.isPaid.FALSE',
    defaultMessage: 'Nezpoplatněné',
  },
});

export const publishsetAdminOnlyMessages = defineMessages<PUBLISHSET_ADMIN_ONLY>({
  [PUBLISHSET_ADMIN_ONLY.TRUE]: {
    id: 'publishsetList.adminOnly.TRUE',
    defaultMessage: 'Neveřejné',
  },
  [PUBLISHSET_ADMIN_ONLY.FALSE]: {
    id: 'publishsetList.adminOnly.FALSE',
    defaultMessage: 'Veřejné',
  },
});

export const publishsetTypeMessages = defineMessages<PUBLISHSET_TYPES>({
  [PUBLISHSET_TYPES.RASTER]: {
    id: 'publishset.type.raster',
    defaultMessage: 'Rastrové',
  },
  [PUBLISHSET_TYPES.VECTOR]: {
    id: 'publishset.type.vector',
    defaultMessage: 'Vektorové',
  },
});

export const publishsetDatatypeMessages = defineMessages<DatatypeEnum>({
  [DatatypeEnum.STANDARD]: {
    id: 'publishset.datatype.STANDARD',
    defaultMessage: 'Standard',
  },
  [DatatypeEnum.UAP]: {
    id: 'publishset.datatype.UAP',
    defaultMessage: 'ÚAP',
  },
});

export const publishsetDtmDataTypeMessages = defineMessages<DtmDataTypeEnum | 'null'>({
  null: {
    id: 'publishset.dtmDataType.null',
    defaultMessage: ' ',
  },
  [DtmDataTypeEnum.DI]: {
    id: 'publishset.dtmDataType.DI',
    defaultMessage: 'Dopravní infrastruktura',
  },
  [DtmDataTypeEnum.TI]: {
    id: 'publishset.dtmDataType.TI',
    defaultMessage: 'Technická infrastruktura',
  },
  [DtmDataTypeEnum.ZPS]: {
    id: 'publishset.dtmDataType.ZPS',
    defaultMessage: 'Základní prostorová situace',
  },
});
